var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZozhLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 122,
    viewBox: "0 0 216 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.599 61.2591L121.569 45.3091L121.379 33.2291C121.379 31.2091 119.739 29.5791 117.729 29.5791H113.709C111.689 29.5791 110.059 31.2191 110.059 33.2291V45.7991L104.779 59.4391C102.499 65.3291 101.319 71.7291 101.319 78.1991V102.289C101.319 106.619 104.319 110.129 108.019 110.129H122.309C126.009 110.129 129.009 106.619 129.009 102.289V76.9891C128.999 71.6191 128.189 66.2991 126.599 61.2591Z",
    fill: "#D8F5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.95 78.0391H101.26V101.949H128.95V78.0391Z",
    fill: "#A9E34B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29 27.0595H112.19C111.37 27.0595 110.7 26.3895 110.7 25.5695V23.5095C110.7 22.6895 111.37 22.0195 112.19 22.0195H119.29C120.11 22.0195 120.78 22.6895 120.78 23.5095V25.5695C120.77 26.3995 120.11 27.0595 119.29 27.0595Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7 27.0596H119.77C120.32 27.0596 120.77 27.5096 120.77 28.0596V28.5796C120.77 29.1296 120.32 29.5796 119.77 29.5796H111.7C111.15 29.5796 110.7 29.1296 110.7 28.5796V28.0596C110.7 27.5096 111.15 27.0596 111.7 27.0596Z",
    fill: "#A9E34B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.509 93.1399C119.509 95.5699 117.539 97.5499 115.099 97.5499C112.669 97.5499 110.689 95.5799 110.689 93.1399C110.689 90.7099 115.099 79.9199 115.099 79.9199C115.099 79.9199 119.509 90.7099 119.509 93.1399Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.646 20.265L149.54 18.6562L147.931 22.7624L152.037 24.3712L153.646 20.265Z",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3602 103.17L84.8502 99.2803L84.2402 106L90.3602 103.17Z",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1596 37.8309C87.0628 37.8309 93.4696 31.4241 93.4696 23.5209C93.4696 15.6177 87.0628 9.21094 79.1596 9.21094C71.2564 9.21094 64.8496 15.6177 64.8496 23.5209C64.8496 31.4241 71.2564 37.8309 79.1596 37.8309Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8998 35.9706C87.803 35.9706 94.2098 29.5638 94.2098 21.6606C94.2098 13.7574 87.803 7.35059 79.8998 7.35059C71.9967 7.35059 65.5898 13.7574 65.5898 21.6606C65.5898 29.5638 71.9967 35.9706 79.8998 35.9706Z",
    fill: "#A9E34B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8691 25.0703C79.0491 27.9803 84.7791 26.9603 87.6891 22.7803",
    stroke: "#74B816",
    strokeWidth: 1.2551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3997 12.6006L73.4397 14.9906L77.1197 13.8506L75.7896 17.4806L78.0196 20.6306L74.1597 20.4806L71.8396 23.5706L70.7896 19.8606L67.1396 18.6106L70.3496 16.4706L70.3997 12.6006Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0801 11.4604L83.8701 10.7304L85.4201 7.19043L87.2901 10.5704L91.1301 10.9504L88.4901 13.7704L89.3201 17.5404L85.8201 15.9004L82.4901 17.8604L82.9601 14.0204L80.0801 11.4604Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43066 80.0299C8.43066 83.1899 11.7207 85.0399 14.9407 84.2599L17.2207 83.7099C27.0607 81.3199 35.8807 75.8299 42.3607 68.0499L42.4507 67.9399C44.0507 66.0199 45.9207 64.3399 47.9907 62.9299C51.5307 60.5199 57.1207 56.4899 58.7007 54.0399C64.2007 45.7899 51.8307 41.6699 51.8307 41.6699",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7304 36.8099C24.6004 45.0299 22.3704 53.6399 16.7604 59.9299L14.8504 62.0699C13.2704 63.8499 11.4004 65.3499 9.32035 66.5199C5.75035 68.5299 3.89035 72.6099 4.71035 76.6299C5.22035 79.1099 7.58035 80.7699 10.0904 80.3999L15.1404 79.6499C23.7004 78.3799 31.4504 73.9099 36.8404 67.1399L45.6404 56.0999L49.0303 52.9899C52.6804 49.6399 53.4104 44.1599 50.7603 39.9699C48.3503 36.1599 44.5804 33.4199 40.2204 32.2899L32.9904 30.4199C32.9904 30.4199 32.5804 33.4199 29.8304 34.7899C27.0804 36.1599 22.6404 36.3999 22.7304 36.8099Z",
    fill: "#A9E34B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.21 49.9102C20.21 49.9102 20.21 45.7902 30.52 49.9102",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4308 53.8895C28.4308 53.8895 21.6108 48.2495 18.8408 53.8895",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3601 58.9301C25.3601 58.9301 21.5801 53.6701 16.0801 57.2901",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 78.7895C17.25 78.7895 21.58 62.2695 36.7 56.7795C51.82 51.2895 42.3 32.9795 42.3 32.9795",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3604 75.5097C25.3604 75.5097 25.7004 63.8197 42.2004 58.9297",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4902 86.6601C39.5002 89.9801 42.0802 92.7301 45.3902 92.9401L47.7302 93.0901C57.8402 93.7601 67.8902 91.1501 76.4102 85.6701L76.5302 85.5901C78.6302 84.2401 80.9202 83.1901 83.3102 82.4701C87.4102 81.2301 93.9402 79.0601 96.1902 77.1901C103.9 70.9701 93.3302 63.3301 93.3302 63.3301",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.02 50.0105C66.34 58.4105 61.64 65.9605 54.41 70.2905L51.95 71.7605C49.91 72.9805 47.67 73.8605 45.34 74.3505C41.33 75.2005 38.33 78.5405 37.92 82.6105C37.66 85.1305 39.42 87.4205 41.92 87.8105L46.96 88.6005C55.5 89.9505 64.24 88.0005 71.41 83.1605L83.11 75.2605L87.28 73.3105C91.77 71.2005 94.1 66.1905 92.83 61.4005C91.67 57.0505 88.9 53.3005 85.07 50.9205L78.72 46.9805C78.72 46.9805 77.43 49.7205 74.4 50.2105C71.37 50.7005 67.06 49.5805 67.02 50.0105Z",
    fill: "#A9E34B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6904 61.7504C60.6904 61.7504 61.9204 57.8204 70.5304 64.8304",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3502 68.0103C67.3502 68.0103 62.5302 60.5903 58.2002 65.1403",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9098 71.9009C62.9098 71.9009 60.8798 65.7509 54.5498 67.5609",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2305 88.4302C49.2305 88.4302 58.3005 73.9702 74.3805 73.2502C90.4505 72.5202 86.8405 52.2002 86.8405 52.2002",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9502 87.7203C57.9502 87.7203 61.7802 76.6703 78.9802 76.9303",
    stroke: "#74B816",
    strokeWidth: 1.3745,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.91 80.6895L177.64 86.2094L156.3 91.2295L155.9 85.1994L174.91 80.6895Z",
    fill: "#5C940D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.28 98.37C153.135 98.37 157.07 94.4346 157.07 89.58C157.07 84.7255 153.135 80.79 148.28 80.79C143.426 80.79 139.49 84.7255 139.49 89.58C139.49 94.4346 143.426 98.37 148.28 98.37Z",
    fill: "#66A80F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8 89.0596C177.54 87.9396 175.78 85.8596 175.15 83.2096C174.03 78.4896 176.95 73.7496 181.67 72.6396C186.39 71.5196 191.13 74.4396 192.24 79.1596C193.01 82.4096 191.87 85.6596 189.55 87.7396",
    fill: "#66A80F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3 90.3301C143.94 93.0301 146.64 94.7001 149.34 94.0601",
    stroke: "#94D82D",
    strokeWidth: 1.2551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.721 81.9395C179.361 84.6395 182.061 86.3094 184.761 85.6694",
    stroke: "#94D82D",
    strokeWidth: 1.2551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.09 86.6201L177.34 89.2201L177.97 94.2001L199.6 91.8601L199.09 86.6201Z",
    fill: "#94D82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55 101.64C175.404 101.64 179.34 97.7042 179.34 92.8496C179.34 87.995 175.404 84.0596 170.55 84.0596C165.695 84.0596 161.76 87.995 161.76 92.8496C161.76 97.7042 165.695 101.64 170.55 101.64Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.62 96.7499C211.475 96.7499 215.41 92.8145 215.41 87.9599C215.41 83.1053 211.475 79.1699 206.62 79.1699C201.765 79.1699 197.83 83.1053 197.83 87.9599C197.83 92.8145 201.765 96.7499 206.62 96.7499Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.52 93.1104C165.89 95.8604 168.42 97.7804 171.17 97.4104",
    stroke: "#E9FAC8",
    strokeWidth: 1.2551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.59 88.2197C201.96 90.9697 204.49 92.8897 207.24 92.5197",
    stroke: "#E9FAC8",
    strokeWidth: 1.2551,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.07 104.34L150.24 121.3",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19 6.37988L134.41 19.4299",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5056 116.069L31.3994 114.46L29.7906 118.566L33.8968 120.175L35.5056 116.069Z",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1504 95.44L27.5304 91.79",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 118.51L30.49 100.31",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.63 36.5701L177.35 28.5801",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4565 22.257L5.81836 26.667L10.2284 34.3051L17.8665 29.8951L13.4565 22.257Z",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26953 1.2998L46.9195 23.8898",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5703 2L55.6503 22.08",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZozhLeftImage);
export default __webpack_public_path__ + "static/media/zozhLeftImage.4d8cab9d68cce5ce02bb6548419dabdb.svg";
export { ForwardRef as ReactComponent };